/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_Again_ButtonInputs */



/**
* | output |
* | --- |
* | "Restore again" |
*
* @param {Assistant_Restore_Again_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_again_button = /** @type {((inputs?: Assistant_Restore_Again_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_Again_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer à nouveau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina di nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить снова")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar de nuevo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("再次恢复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再度復元")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुनः पुनर्स्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar novamente")
	return /** @type {LocalizedString} */ ("Restore again")
});